import React from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'
import CommonImage from './CommonImage'

const CommonAvatar = ({
  className,
  src,
  width,
  height,
  alt,
  username,
  follower,
  fontSize,
  strong,
  color,
  ...props
}) => {
  const userFontStyle = {
    username,
    fontWeight: strong ? 'bold' : undefined,
    fontSize,
    color,
  }
  const followFontStyle = {
    follower,
    fontWeight: strong ? 'bold' : undefined,
    fontSize,
    color: '#ABAFB4',
  }

  return (
    <AvatarWrapper
      className={className}
      follower={follower}
      width={width}
      height={height}
      {...props}>
      <CommonImage
        src={src}
        alt={alt}
        style={{ borderRadius: '100%', width: '100%', height: '100%' }}
      />
      <AvatarInfo className={className} follower={follower}>
        <div username={username} style={{ ...userFontStyle }}>
          {username}
        </div>
        <div follower={follower} style={{ ...followFontStyle }}>
          {follower}
        </div>
      </AvatarInfo>
    </AvatarWrapper>
  )
}

CommonAvatar.propTypes = {
  src: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  alt: PropTypes.string,
  username: PropTypes.string,
  follower: PropTypes.string,
  fontSize: PropTypes.number,
  strong: PropTypes.bool,
  color: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}
const AvatarWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  ${({ follower }) =>
    !follower &&
    css`
      flex-direction: column;
      text-align: center;
      justify-content: space-evenly;
    `}
  width: ${props => `${props.width}px`};
  height: ${props => `${props.height}px`};
`
const AvatarInfo = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  ${({ follower }) =>
    follower &&
    css`
      margin-left: 30px;
    `}
`

export default CommonAvatar
